<template>
  <div class="object-attribute">
    <div>
      <label class="app__label" for="objectAttrLanguage">
        {{ $t("object_attr_lang") }}
      </label>
      <el-select
        id="objectAttrLanguage"
        v-model="currentLanguage"
        filterable
        @change="changeAttributeLang"
      >
        <el-option
          v-for="item in languages"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>

      <el-table
        class="object-attribute__table"
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        style="width: 100%;"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column :label="$t('object_attr_name')">
          <template slot-scope="scope">
            <span v-if="scope.row.required" class="object-attribute__table_req">
              *
            </span>
            {{ scope.row.name }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('object_attr_value')" width="240">
          <template slot-scope="scope">
            <attribute-value-component
              :attributeId="scope.row.attributeId"
              :type="scope.row.attributeType"
              :value="scope.row.value"
              :references="references"
              :required="isRequaredField(scope.row)"
              @change="change"
              @click="click"
            />
          </template>
        </el-table-column>

        <el-table-column width="100" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="bottom"
              width="260"
              v-model="scope.row.deleteConfirm"
            >
              <p>{{ $t("confirmed_delete") }}</p>
              <div style="text-align: right; margin: 0;">
                <el-button
                  size="mini"
                  type="text"
                  @click="scope.row.deleteConfirm = false"
                >
                  {{ $t("cancel") }}
                </el-button>

                <el-button
                  type="primary"
                  size="mini"
                  @click="deleteItem(scope.row.value.id)"
                >
                  {{ $t("confirm") }}
                </el-button>
              </div>
              <el-button
                slot="reference"
                type="warning"
                icon="el-icon-delete"
                :title="$t('object_attr_delete_title')"
                :disabled="disabledDelete(scope.row)"
              ></el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="object-attribute_action">
      <el-checkbox
        v-model="editableObjectDone"
        class="object-attribute_action_item"
        @change="changeObjectDone"
      >
        {{ $t("object_attr_done") }}
      </el-checkbox>

      <el-button
        class="object-attribute_action_item"
        icon="el-icon-magic-stick"
        disabled
      >
        {{ $t("object_attr_translate") }}
      </el-button>

      <el-button
        class="object-attribute_action_item"
        type="info"
        icon="el-icon-view"
        @click="showInfo"
      >
        {{ $t("object_attr_view") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import AttributeValueComponent from "./AttributeValueComponent.vue";

import * as systemService from "@/domain/object/system.service";

export default {
  name: "ObjectAttribute",
  components: {
    AttributeValueComponent
  },
  props: {
    attributes: Array,
    loading: Boolean,
    references: Object,
    languages: Array,
    languagesUsed: Array,
    objectCard: Object
  },
  data() {
    return {
      editableObjectDone: false,
      language: "",
      currentLanguage: ""
    };
  },
  computed: {
    tableData() {
      return this.attributes || [];
    },
    isPublicLang() {
      return this.languagesUsed.some(lang => lang === this.currentLanguage);
    }
  },
  methods: {
    change(val) {
      this.$emit("action", { ...val, event: "change" });
    },
    click(val) {
      this.$emit("action", { ...val, event: "click" });
    },
    deleteItem(val) {
      this.$emit("delete", val);
    },
    changeAttributeLang() {
      this.$emit("changeCurrentLanguage", this.currentLanguage);
    },
    setCurrentLang() {
      this.currentLanguage = this.$store.state.objectSetting.currentLanguage;
    },
    setObjectDone() {
      this.editableObjectDone = this.objectCard.done;
    },
    changeObjectDone(val) {
      let result = { ...this.objectCard };
      result.done = val;
      return this.$emit("changeCard", result);
    },
    showInfo() {
      this.$emit("showInfo");
    },
    isRequaredField(row) {
      return row.required && this.isPublicLang;
    },
    disabledDelete(row) {
      if (this.isRequaredField(row)) {
        return true;
      }

      let type = row.attributeType.type;
      if (systemService.isArrayType(type)) {
        let lowerType = type.toLowerCase();
        let val = row.value[lowerType];
        return !(val && Array.isArray(val) && val.length > 0);
      } else if (systemService.isMemo(type)) {
        let lowerType = type.toLowerCase();
        return row.value[lowerType] && row.value[lowerType].length === 0;
      }

      return !row.value.id;
    }
  },
  mounted() {
    this.setCurrentLang();
    this.setObjectDone();
  },
  watch: {
    objectCard: function () {
      this.setObjectDone();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.object-attribute {
  padding: $component_padding_on_top $component_padding_on_left;
  height: calc(100% - 30px);
  overflow: auto;

  .object-attribute__table {
    margin-top: $component_padding_on_top;
    max-height: calc(100% - 80px);
    overflow: auto;

    .object-attribute__table_req {
      color: $danger_color;
    }
  }

  .object-attribute_action {
    width: 100%;
    padding: $component_padding_on_top 0;
    text-align: right;
    position: sticky;
    bottom: -22px;
    background-color: $main_background_color;
    z-index: 4;

    .object-attribute_action_item {
      margin-left: 10px;
    }

    .object-attribute_action_item:first-child {
      margin-left: 0;
    }
  }
}
</style>
